/* eslint-disable */
import {
  Dropdown,
  Form,
  Input,
  Modal,
  Select,
  Steps,
  Table,
  DatePicker,
  Space,
  Tooltip,
    Button,
} from "antd";
import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
  useRef,
  useCallback,
  useMemo
} from "react";
const { Step } = Steps;
import { Typography } from "antd";
const { Text, Link } = Typography;
import http from "@/utils/http";
import api from "@/utils/api";
import "../../OpenTable.css";
import moment from "moment";
import { FormOutlined, MenuOutlined, HistoryOutlined } from "@ant-design/icons";
import commonFn from "@/utils/commonFn";
import createSorter from '@/components/createSorter';
import { CustomTable } from "@/hocComponents";
import { useNavigate } from "react-router-dom";
const { RangePicker } = DatePicker;
const MainTable = forwardRef((props, ref) => {
  const childRef = useRef();
  const [error, setError] = useState(null);
  const [filteredData, setFilteredData] = useState([]); // 筛选后的数据
    const [tableList, setTableList] = useState([]); // 表格数据
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 100,
    total: 0,
  });
   const [tableLoading, setTableLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [options, setOptions] = useState([10, 20, 30]); 
  const [selectedList, setSelectedList] = useState([]);
  const [selectedDateRange, setSelectedDateRange] = useState(null);
  const [total, setTotal] = useState(0);
  const inputRefs = useRef({});
  const [refreshKey, setRefreshKey] = useState(0);
  const initialTableHead = {
    status: "open",
    remark: null,
    assignedToName: null,
    PropUnit: null,
    unitStatus: null,
    propType: null,
    units: null,
    unitAddress: null,
    city: null,
    sCreateTime: null,
    eCreateTime: null,
    groupSupervisor: null,
  };
  const [tableHead, setTableHead] = useState(initialTableHead);
  const navigate = useNavigate();
  const [pickerDates, setPickerDates] = useState(null);
  const items = [
    {
      key: "edit",
      icon: <FormOutlined style={{ color: "#00c0ef", fontSize: "17px" }} />,
      label: <div>Edit Approval Information</div>,
    },
  ];
  const handleOk = (dates, confirm, startKey, endKey) => {
  if (dates && dates.length === 2) {
    const startDate = dates[0].format("MM/DD/YYYY");
    const endDate = dates[1].format("MM/DD/YYYY");
    const startTime = dates[0].valueOf();
    const endTime = dates[1].valueOf();

    handleApiCall(startDate, endDate, startTime, endTime, confirm, startKey, endKey);
  } else {
    return;
  }
};

  // 通用的 API 调用
const handleApiCall = async (
  startDate,
  endDate,
  startTime,
  endTime,
  confirm,
  startKey,
  endKey
) => {
  console.log("Fetching data for:", startDate, endDate);
  setTableHead((prev) => {
    const updatedTableHead = {
      ...prev,
      [startKey]: startTime,
      [endKey]: endTime,
    };
    console.log("Updated tableHead:", updatedTableHead);
    getTableListFn(1, pagination.pageSize, updatedTableHead);
    return updatedTableHead;
  });
  if (confirm) {
    confirm(); //  关闭下拉
  }
};
// 通用 Reset
const handleReset = (setDates, startKey, endKey, clearFilters) => {
  clearFilters?.();
  setDates([]);
  setTableHead((prev) => {
    const updatedTableHead = {
      ...prev,
      [startKey]: "",
      [endKey]: "",
    };
    getTableListFn(1, pagination.pageSize, updatedTableHead);
    return updatedTableHead;
  });
};


  // 暴露子组件方法
  useImperativeHandle(ref, () => ({
    getValue: () => columns,
    toggleColumnVisibility: (checkedValues) => {
      setColumns((prevColumns) => {
        return prevColumns.map(
          (col) =>
            checkedValues.includes(col.key)
              ? { ...col, hidden: false } // 如果列的 key 在 checkedValues 中，显示该列
              : { ...col, hidden: true } // 否则隐藏该列
        );
      });
    },
    // input 搜索
    getSearchValues: () => {
      return {
        completedByName: inputRefs.current.completedByName?.input?.value || "",
        remark: inputRefs.current.remark?.input?.value || "",
        assignedToName: inputRefs.current.assignedToName?.input?.value || "",
        propUnit: inputRefs.current.propUnit?.input?.value || "",
        unitStatus: inputRefs.current.unitStatus?.input?.value || "",
        propType: inputRefs.current.propType?.input?.value || "",
        units: inputRefs.current.units?.input?.value || "",
        unitAddress: inputRefs.current.unitAddress?.input?.value || "",
        city: inputRefs.current.city?.input?.value || "",
      };
    },
    newListFun: () => {
      Object.keys(inputRefs.current).forEach((key) => {
        if (inputRefs.current[key]) {
          inputRefs.current[key].input.value = "";
        }
      });

      setRefreshKey((prev) => prev + 1);
      setTableHead(initialTableHead);
        getTableListFn(pagination.current, pagination.pageSize, tableHead);
    },
  }));


  const handleDetailClick = (record) => {
    console.log("record", record);
    const params = record;
    const baseUrl = window.location.origin;
    const route = "/JobRequests/NonMaintenanceRequest/Details";
    const paramString = new URLSearchParams(params).toString();
    // console.log(paramString);
    const hash = `${route}${paramString ? `?${paramString}` : ""}`;
    const url = `${baseUrl}#${hash}`;
    window.open(url, "_blank", "noopener,noreferrer");
  };

    const tableFilterFn = (event, key, type = "Input") => {
      commonFn.tableFilterFn({ event, key, type, setTableHead, getTableListFn });
    };

  // 定义列，包括输入框
  const initColumns = [
    // {
    //   title: "#",
    //   key: "#", // 必须添加唯一的key
    //   dataIndex: "#",
    //   hidden: false,
    //   align: "center",
    //   width: 50, // 设置列宽防止冲突
    //   render: (text, record, index) =>
    //     (pagination.current - 1) * pagination.pageSize + index + 1, // 计算序号
    // },
    {
      title: "Action",
      key: "action",
      dataIndex: "index",
      hidden: false,
      align: "center",
      width: 60,
      render: (text, record) => (
        commonFn.btnAuthorityFlag('ViewDetail') && (<Dropdown
          menu={{
            items: [
              {
                key: "view",
                icon: <HistoryOutlined twoToneColor="#1677FF" />,
                label: <div>View Detail</div>,
              },
            ],
            onClick: (e) => handleDetailClick(record),
          }}
          trigger={["click"]}
        >
          <MenuOutlined className="col-blue" />
        </Dropdown>) || null
      ),
    },
    {
      title: "Create Date",
      dataIndex: "createTime",
      key: "createTime",
      width: 170,
      align: "center",
      sorter: true,
      filterDropdown: ({ confirm, clearFilters }) => (
        <div style={{ padding: 8 }}>
          <RangePicker
            allowClear={false}
            format="MM/DD/YYYY"
            value={pickerDates}
            onChange={(dates) => {
              setPickerDates(dates);
              handleOk(dates, confirm, "sCreateTime", "eCreateTime");
            }}
          />
          <Button
            size="small"
            style={{ width: 60, marginLeft: 10 }}
            onClick={() =>
              handleReset(
                setPickerDates,
                "sCreateTime",
                "eCreateTime",
                clearFilters
              )
            }
          >
            Reset
          </Button>
        </div>
      ),
      render: (text) => moment(text).format("MM/DD/YYYY HH:mm"),
    },

     {
      title: "Remark",
      dataIndex: "remark",
      titleType: "Input",
      width: 220,
      isSorter: true,
      sortterMultiple: 3,
      onChange: (e) => tableFilterFn(e, "remark"),
    },

    {
      title: "Group-Supervisor",
      dataIndex: "groupSupervisor",
      titleType: "Input",
      width: 180,
      isSorter: true,
      sortterMultiple: 3,
      onChange: (e) => tableFilterFn(e, "groupSupervisor"),
    },
   {
      title: "Assigned",
      dataIndex: "assignedToName",
      titleType: "Input",
       width: 160,
      isSorter: true,
      sortterMultiple: 3,
      onChange: (e) => tableFilterFn(e, "assignedToName"),
    },
    {
      title: "Prop-Unit",
      dataIndex: "propUnit",
      titleType: "Input",
        width: 140,
      isSorter: true,
      sortterMultiple: 3,
      onChange: (e) => tableFilterFn(e, "propUnit"),
    },
    {
      title: "Unit Status",
      dataIndex: "unitStatus",
      titleType: "Input",
      width: 120,
      isSorter: true,
      sortterMultiple: 3,
      onChange: (e) => tableFilterFn(e, "unitStatus"),
    },

    {
      title: "Prop Type",
      dataIndex: "propType",
      titleType: "Input",
      width: 120,
      isSorter: true,
      sortterMultiple: 3,
      onChange: (e) => tableFilterFn(e, "propType"),
    },
   {
      title: "Units",
      dataIndex: "units",
      titleType: "Input",
        width: 100,
      isSorter: true,
      sortterMultiple: 3,
      onChange: (e) => tableFilterFn(e, "units"),
    },
    {
      title: "Unit Address",
      dataIndex: "unitAddress",
      titleType: "Input",
      width: 280,
      isSorter: true,
      sortterMultiple: 3,
      onChange: (e) => tableFilterFn(e, "unitAddress"),
    },
  {
      title: "City",
      dataIndex: "city",
      titleType: "Input",
      width: 140,
      isSorter: true,
      sortterMultiple: 3,
      onChange: (e) => tableFilterFn(e, "city"),
    },
  ];
  const columns = useMemo(() => {
  return initColumns.map((col) => {
    if (col.dataIndex === "#") {
      return {
        ...col,
        render: (text, record, index) =>
          (pagination.current - 1) * pagination.pageSize + index + 1,
      };
    }
    return col;
  });
}, [initColumns, pagination.current, pagination.pageSize])
  //初始化数据
  const layout = {
    labelCol: {
      span: 6,
    },
    wrapperCol: {
      span: 16,
    },
  };

  const { confirm } = Modal;
  // 时间非空判断
  const isValidDate = (e) => {
    return e && !isNaN(new Date(e));
  };
  useEffect(() => {
    if (
      (tableHead.sCompletedTime && tableHead.eCompletedTime) ||
      (tableHead.sCreateTime && tableHead.eCreateTime)
    ) {
      getTableListFn(1, 100, tableHead); // 查询全部数据
    }
  }, [
    tableHead.sCompletedTime,
    tableHead.eCompletedTime,
    tableHead.sCreateTime,
    tableHead.eCreateTime,
  ]);
  // 初始化数据
  useEffect(() => {
    setTableLoading(true);
    getTableListFn(pagination.current, pagination.pageSize);
  }, [childRef]);


  //列表
  const getTableListFn = async (page, pageSize, params = {}) => {
    try {
            setTableLoading(true);
        const queryParams = {
        page,
        count: pageSize,
        status: "open",
        assignedToName: params.assignedToName || "",
        remark: params.remark || "",
        groupSupervisor: params.groupSupervisor || "",
        propUnit: params.propUnit || "",
        unitStatus: params.unitStatus || "",
        propType: params.propType || "",
        units: params.units || "",
        city: params.city || "",
        unitAddress: params.unitAddress || "",
        sCompletedTime: params.sCompletedTime || "",
        eCompletedTime: params.eCompletedTime || "",
        sCreateTime: params.sCreateTime || "",
        sCreateTime: params.eCreateTime || "",
        orderField: params.orderField || "",
        orderType: params.orderType || "",
      };
         // 过滤掉空值参数
            const filteredParams = Object.fromEntries(
              Object.entries(queryParams).filter(([_, v]) => v !== "")
            );
            // 先发送请求获取 response
            const response = await http.get(`${api.onpenMaintenanceShow}`, {
              params: filteredParams,
            });

      const dataWithKey = (response.data.list || [])?.map((item) => ({
        ...item,
        key: item.id,
      }));

      setTableLoading(false);
      setFilteredData(dataWithKey);
           setTableList(dataWithKey);
      setTotal(response.data.total);
 
      setPagination((prev) => ({
        ...prev,
        current: page,
        total: response.data.total,
        pageSize: pageSize,
      }));
      console.log(pagination);
      props.updateMessage(dataWithKey);
    } catch (err) {
      setError(err);
    } finally {
      setTableLoading(false);
    }
  };

   // 处理分页变化    table筛选
  const handleTableChange = (newPagination, filters, sorter) => {
    console.log("跳转");
    // 需要传递当前的 tableHead 搜索条件 \搜索
    let orderField = "";
    let orderType = "";
    if (sorter && sorter.field) {
      orderField = sorter.field;
      orderType = sorter.order === "ascend" ? "asc" : "desc";
    }
    // getTableListFn(newPagination.current, newPagination.pageSize, tableHead);
    getTableListFn(newPagination.current, newPagination.pageSize, {
      ...tableHead,
      orderField,
      orderType,
    });
  };
  const handlePageSizeChange = useCallback((value) => {
    setPageSize(value);
    setCurrentPage(1); // 切换 pageSize 后，重置页码
  }, []);

  const itemRender = useCallback(
    (current, type, originalElement) => {
      if (type === "next") {
        return (
          <div style={{ display: "flex", alignItems: "center" }}>
            {originalElement}
            <Select
              defaultValue={pageSize}
              className="select-style"
              style={{ width: 80, margin: "0 10px" }}
              onSelect={handlePageSizeChange}
              options={options.map((item) => ({
                value: item,
                label: `${item} `,
              }))}
            />
          </div>
        );
      }
      return originalElement;
    },
    [pagination.pageSize, handlePageSizeChange, options]
  );

  //复选框
  const rowSelection = {
    getCheckboxProps: (record) => ({
      style: record.isEmpty ? { display: "none" } : {}, // 隐藏复选框
    }),
    onChange: (selectedRowKeys, selectedRows) => {
      //选中
      // console.log(selectedRowKeys);
      console.log(selectedRows);
      setSelectedList(selectedRows);
      props.deleteNum(selectedRows); //调用父组件方法
    },
  };

  return (
    <div>
        <CustomTable
          rowSelection={{
            type: "checkbox",
            ...rowSelection,
          }}
          refreshKey={refreshKey}
          tableLoading={tableLoading}
          columns={columns}
          tableList={tableList}
          pagination={pagination}
          // handleTableChange={handleTableChange}
          tableCss="maintenanceTable"
          setTableHead={setTableHead} // 必需
          getTableListFn={getTableListFn} //
        />
    </div>
  );
});
export default MainTable;
